import type { DateRangePair } from "~/components/plus/date-picker/types";
import type { PlusDetailedListingType } from "~/components/plus/detailed-listing-popup/types";
import { article as articleData } from "~/data/article";

export const DefaultFilterRange: DateRangePair = [undefined, undefined];

export const DataMap = {
  [articleData.types.dailyPulseBriefing.entityId]: {
    title: "Daily Pulse",
    type: "daily-pulse",
  },
  [articleData.types.quickDigest.entityId]: {
    title: "Quick Digest",
    type: "quick-digest",
  },
  [articleData.types.factSheet.entityId]: {
    title: "FactSheet",
    type: "fact-sheet",
  },
  [articleData.types.infographic.entityId]: {
    title: "Infographic",
    type: "infographic",
  },
} as Record<
  string,
  {
    title: string;
    type:
      | Extract<PlusDetailedListingType, "daily-pulse" | "quick-digest" | "fact-sheet">
      | "infographic";
  }
>;
